// Variante do badge por família de status das entidades de autorização (versão da matriz, atribuição, regra de SoD,
// break-glass, campanha/item, aprovação de duas chaves). Puro, sem React: testável e fora do componente (Fast Refresh).
const POSITIVE = new Set([
  'Published',
  'Active',
  'Completed',
  'Closed',
  'Decided',
  'Justified',
  'Keep',
]);
const PENDING = new Set([
  'Draft',
  'PendingSecondKey',
  'Scheduled',
  'Open',
  'Pending',
  'PendingReview',
]);
const NEGATIVE = new Set([
  'Revoked',
  'Expired',
  'Cancelled',
  'Ended',
  'Superseded',
  'Unjustified',
  'Revoke',
]);

export type BadgeVariant = 'default' | 'secondary' | 'destructive' | 'outline';

export function statusVariant(status: string): BadgeVariant {
  if (POSITIVE.has(status)) {
    return 'default';
  }
  if (PENDING.has(status)) {
    return 'secondary';
  }
  if (NEGATIVE.has(status)) {
    return 'destructive';
  }
  return 'outline';
}
